<template>
	<div class="post-card">
		<div class="cover" v-if="coverUrl" :style="{ 'background-image': `url(${coverUrl})` }"></div>
		<div class="text">
			<div class="date">{{ data.date | moment('D MMM Y') }}, {{ authorName }}</div>
			<div class="title">{{ title }}</div>

			<div class="excerpt" v-html="excerpt"></div>

			<div class="tags" v-if="data.categories && data.categories.length">
				<div v-for="catid in data.categories" :key="catid" class="tag">{{ categories[catid].name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'post-card',

	props: {
		data: {
			type: Object,
			required: true
		},

		tags: {
			type: Object,
			default: () => ({})
		},

		categories: {
			type: Object,
			default: () => ({})
		}
	},

	computed: {
		/**
		 * 
		 */
		coverUrl() {
			const media = (
				this.data &&
				this.data._embedded &&
				this.data._embedded['wp:featuredmedia'] &&
				this.data._embedded['wp:featuredmedia'][0]
			)

			return media && media.source_url ? media.source_url : null
		},

		/**
		 * 
		 */
		authorName() {
			const author =
				this.data &&
				this.data._embedded &&
				this.data._embedded.author &&
				this.data._embedded.author[0]

			return author && author.name ? author.name : 'Autore'
		},

		/**
		 * 
		 */
		title() {

			return this.data ? this.data.title.rendered : 'Article'
		},

		/**
		 * 
		 */
		excerpt() {

			return this.data ? this.data.excerpt.rendered : null
		}
	}
}
</script>

<style lang="stylus" scoped>
.post-card
	background-color dark

	position relative

	@media (max-width: unit(768, px))
		margin-bottom 2em

	.cover
		position relative

		background-size cover
		background-position center

		&:after
			content ''

			display block

			position relative

			padding-bottom 50%

	.text
		padding 1em

		.date
			color secondary

			font-size 0.8em

		.title
			margin 0.5em auto

			color primary

			font-size 1.6em
			font-weight bold

			&:before
				

				margin-right 0.5em

				font-size 1.2em
		
		.content
			white-space normal
		
		.tags
			display flex
			align-content center
			flex-wrap wrap

			margin 1em auto

			&.float
				width 100%

				position absolute
				bottom 0
			&:not(.float)
				opacity 1

			.tag
				margin 0.4em
				padding 0.4em
				border-radius 0.4em

				background-color secondary
				color light

				font-family fontSans
				font-size 0.8em
				font-weight bold
</style>
